import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import TablaCalificacion from '../../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../../exportacion_react_pdf/TextAreaLabelGroup';
import TextAreaLabel from '../../../../exportacion_react_pdf/TextAreaLabel';

const secciones_agricola = [
    {
        key: '1',
        title: '1. PLANIFICACION PREDIAL/MANEJO DE LA UNIDAD PRODUCTIVA',
        questions: [
            {
                section: '1.1',
                description: 'El/la productor/a  identifica  las variables de planificacion predial para su sistema productivo y cuenta con una programacion y planificacion (Inventarios, procesos, fechas de siembra y cosecha, proyeccion de ventas, etc?',
            },
            {
                section: '1.2',
                description: 'El/la productor/a  identiifica las distancias de siembra adecuadas de acuerdo al tipo de terreno y cultivo?',
            },
            {
                section: '1.3',
                description: 'El/la productor/a reconoce las carateristicas del sistema productivo',
            },
            {
                section: '1.4',
                description: 'El/la productor/a sabe que son las Buenas Prácticas Agrícolas (BPA)?',
            },
            {
                section: '1.5',
                description: 'El/la productor/a reconoce la importancia de manejo de regsitros y lleva registros productivos (rendimiento /Ha), monitoreo de plagas y enfermedades , de fertilización, comerciales, de costos de produccion?',
            },
        ],
    },
    {
        key: '2',
        title: '2. COSTOS DE PRODUCCION ',
        questions: [
            {
                section: '2.1',
                description: 'El/la productor/a identifica las variables o rubros asociados a sus costos de producccion y conoce los costos de su sistema productivo?',
            },
            {
                section: '2.2',
                description: 'El/la productor/a  reconoce y sabe las calidades del producto (tamaño, color, estado de madurez) que requiere el mercado y el valor por cda calidad',
            },
        ],
    },
    {
        key: '3',
        title: '3. INFRAESTRUCTURA PRODUCTIVA',
        questions: [
            {
                section: '3.1',
                description: 'El/la productor/a  reconoce y sabe utilizar las infrestructura necesaria para el manejo postcosecha?',
            },
        ],
    },
    {
        key: '4',
        title: '4. NUTRICIÓN (FERTILIZACIÓN)',
        questions: [
            {
                section: '4.1',
                description: 'El/la productor/a  identifica el momento adecuado para realizar las fertiizaciones de acuerdo a las etapas fenológicas del cultivo?',
            },
            {
                section: '4.2',
                description: 'El/la productor/a  identifica el la función de los elementos  mayores, secundarios y menores en la nutrición del cultivo? ',
            },
            {
                section: '4.3',
                description: 'El/la productor/a identifica las fuentes de f ertilizacióncomerciales y alternativas de la zona, para la nutrición de su cultivo  (abonos orgánicos, bioabonos,  lixiviados, hongos benéficos del suelo, micorrizas, etc) ?',
            },
        ],
    },

    {
        key: '5',
        title: '5. MANEJO INTEGRADO DE PLAGAS Y ENFERMEDADES (MIP)',
        questions: [
            {
                section: '5.1',
                description: 'El/la productor/a  identifica  o reconoce las principales plagas y enfermedades que atacan a los cultivos que tiene en su finca?',
            },
            {
                section: '5.2',
                description: 'El/la productor/a  identifica  o reconoce las principales prácticas culturales a realizar para prevenir y controlar las plagas y enfermedades en su cultivos/s?',
            },
            {
                section: '5.3',
                description: 'El/la productor/a implementa prácticas y técnicas para la prevención, tratamiento y atención de enfermedades?.',
            },
        ],
    },


    {
        key: '6',
        title: '6. BUENAS PRACTICAS PARA SISTEMA PRODUCTIVO',
        questions: [
            {
                section: '6.1',
                description: 'El/la productor/a identifica las etapas fenológicas del cultivo (germinación, estado vegetativo, floración, fructificación) y los tiempos de cada etapa de siembra a cosecha',
            },
            {
                section: '6.2',
                description: 'El/la productor/a identifica las características de la variedad o clon sembrado y cómo potenciar su expresión en el predio?',
            },

        ],
    },


    {
        key: '7',
        title: '7. PROTECCION DE ECOSISTEMAS, SALUD DEL SUELO Y MANEJO DE RESIDUOS Y CUIDADO DEL AGUA',
        questions: [
            {
                section: '7.1',
                description: 'El/la productor/a reconoce practicas de uso de abonos organicos, manejo regenerativo y  labranza sostenible para la salud del suelo?',
            },
            {
                section: '7.2',
                description: 'El/la productor/a reconoce la clasificacion de residuos organicos que produce y su manejo para beneficio de la finca?',
            },
            {
                section: '7.3',
                description: 'El /la productor/a reconoce los residuos peligrosos y conoce las practicas para su adecuada disposición?',
            },
            {
                section: '7.4',
                description: 'El/la productor/a reconoce practicas de cosecha de agua para epocas de sequia y su manejo?',
            },

        ],
    },
];
// Define el documento
const ExportAgricolaPaso7 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.title_1}>CAPACIDADES AGRICOLA</Text>

            <TablaCalificacion evaluacion={formData?.capacidades_agricola} secciones={secciones_agricola}></TablaCalificacion>


        </View>

    </>
);

export default ExportAgricolaPaso7;